export default "__VITE_ASSET__gLBd0XQH__";